/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Default_ClearedInputs */

const cs_templates_default_cleared = /** @type {(inputs: Templates_Default_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí šablona zrušena`)
};

const en_templates_default_cleared = /** @type {(inputs: Templates_Default_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default cleared`)
};

/**
* | output |
* | --- |
* | "Default cleared" |
*
* @param {Templates_Default_ClearedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_default_cleared = /** @type {((inputs?: Templates_Default_ClearedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Default_ClearedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_default_cleared(inputs)
	return cs_templates_default_cleared(inputs)
});